import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image"

const About_1 = props => {
    const data = useStaticQuery(graphql`
        query Office1 {
            file(relativePath: { eq: "offices/A1_Kontor.jpg" }) {
                childImageSharp {
                    gatsbyImageData(layout: CONSTRAINED, width: 1200, formats: [WEBP, AVIF])
                }
            }
        }
    `)

    return (
        <GatsbyImage 
            {...props}
            image={data.file.childImageSharp.gatsbyImageData} 
        />
    )
}


export default About_1
